import React from "react";
import { List as RaList, TextField } from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import EditButton from "./buttons/EditButton";
import RangeField from "./fields/RangeField";
import Filters from "./Filters";

const List = (props) => {
	const classes = useListStyles();
	return (
		<RaList
			{...props}
			classes={classes}
			filters={<Filters />}
			perPage={perPage(50, 25)}
			sort={{ field: "day", order: "DESC" }}
		>
			<ResponsiveList
				mobileHeader={
					<React.Fragment>
						<RangeField
							source="day"
							variant="subtitle1"
							style={{ fontWeight: "bold" }}
						/>
						<EditButton />
					</React.Fragment>
				}
				mobileBody={
					<React.Fragment>
						<TextField source="user.name" />
						<TextField source="bookmaker.name" />
						<TextField source="amount" />
					</React.Fragment>
				}
			>
				<RangeField source="day" />
				<TextField source="user.name" />
				<TextField source="bookmaker.name" />
				<TextField source="amount" />
				<EditButton />
			</ResponsiveList>
		</RaList>
	);
};
export default List;
